import { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Panel } from "primereact/panel";
import { TabPanel, TabView } from "primereact/tabview";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { PersonaNaturalService } from "../../../service/personaNatural/PersonaNaturalService";
import { GenericComponent } from "../../../components/GenericComponent";
import { InputComponent } from "../../../components/InputComponent";
import { useToken } from "../../../components/useToken";
import { FileComponent } from "../../../components/FileComponent";
import { DatosGenerales } from "./DatosGenerales";
import { Divider } from "primereact/divider";
import { InformacionLaboral } from "./InformacionLaboral";
import { InfFinanciera } from "./InfFinanciera";
import { Ampliada } from "./Ampliada";
import { FormPep } from "../FormPep";
import { Dialog } from "primereact/dialog";
import { FileBvg } from "../../../components/FileBvg";
import { Generico } from "../../../components/Generico";
import { ClientePnBvg } from "../../../models/ClientePnBvg";
import { Cancelar } from "../Cancelar";
import { VinculacionBvg } from "../fun/VinculacionBvg";

export const PersonaNatural = () => {

    const generic = new GenericComponent();
    const { accionesTbl } = Generico();
    const omodel = new ClientePnBvg();
    const [clientespn, setClientespn] = useState([]);
    const clientepnSrv = new PersonaNaturalService();
    const toast = useRef(null);
    const [dialogClientepn, setDialogClientepn] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [permss, setPermss] = useState(null);
    const { getPerss, getRol, getInfo, removeKey } = useToken();
    const [siCliente, setSiCliente] = useState(false);
    const [urls, setUrls] = useState();
    const [urlsPep, setUrlsPep] = useState();
    const [dialogSubir, setDialogSubir] = useState(false);
    const [dialogSubirPep, setDialogSubirPep] = useState(false);
    const [hayPep, setHayPep] = useState(false);
    const [pepEstado, setPepEstado] = useState(null);
    const [fpendiente, setFpendiente] = useState(null);
    const [estados, setEstados] = useState(null);
    const [dialogCancelar, setDialogCancelar] = useState(false);
    const filters = [fpendiente, estados];
    const [opcion, setOpcion] = useState(null);
    const [hayTercero, setHayTercero] = useState(false);
    const [vinEstado, setVinEstado] = useState(null);
    const [urlsVin, setUrlsVin] = useState(null);
    const [dialogVinculacion, setDialogVinculacion] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers: clientespn, omodel, generic, permss, id: cliente?.id, filters });

    const { dialogInstruccion, setdialogIns } = FileComponent({ generic, tipo: 'clientePn', toast, permss, id: cliente?.id });

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/persona-natural',
            urlDownload: 'ficha/persona-natural/descarga',
            urlGenerar: 'ficha/persona-natural/generar-consulta',
            urlUpload: 'ficha/persona-natural/store',
            udelete: 'ficha/persona-natural/eliminar-anexo',
            uactual: 'ficha/persona-natural/editar',
            uenviar: 'ficha/persona-natural/enviar',
            uaprobar: 'ficha/persona-natural/aprobar'
        });
        setUrlsPep({
            urlListado: 'ficha/pep-ficha',
            urlDownload: 'ficha/pep-ficha/descarga',
            urlUpload: 'ficha/pep-ficha/store',
            urlVerificacion: 'ficha/pep-ficha',
            udelete: 'ficha/pep-ficha/eliminar-anexo',
            uactual: 'ficha/pep-ficha/editar',
            uenviar: 'ficha/pep-ficha/enviar',
            uaprobar: 'ficha/pep-ficha/aprobar',
            urlGenerar: 'ficha/pep-ficha/generar-consulta',
        });
        setUrlsVin({
            urlListado: 'ficha/vinculacion',
            urlDownload: 'ficha/vinculacion/descarga',
            urlUpload: 'ficha/vinculacion/store',
            udelete: 'ficha/vinculacion/eliminar-anexo',
            uactual: 'ficha/vinculacion/editar',
            uenviar: 'ficha/vinculacion/enviar',
            uaprobar: 'ficha/vinculacion/aprobar',
        });
        setSiCliente(getPerss() !== undefined);

        if (getPerss() === undefined) {
            loadLazyData();
        } else {
            setPermss(getPerss());
            if (getInfo('oid')) {
                confirmCarga();
            } else {
                editFicha(false);
            }
        }
    }, [lazyParams]);

    const confirmCarga = () => {
        const message = 'Se ha detectado un formulario anterior ingresado, ¿Quiere recuperar la información?';
        confirmDialog({
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            style: { maxWidth: '400px' },
            accept: () => editFicha(true),
            reject: () => {
                removeKey('oid');
                editFicha(false);
            }
        });
    }

    const loadLazyData = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        clientepnSrv.getClientepn({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setClientespn(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
                setFpendiente(res.data.cats.pendiente);
                setEstados(res.data.cats.estados);
            }
        });
    }

    const openNew = () => {
        setDialogClientepn(true);
        setCliente(null);
        setdialogIns(true);
        setHayTercero(false);
        setHayPep(false);
    }

    const editFicha = (cargar = false) => {
        if (catalogos === null) {
            clientepnSrv.newClientepn({ iniciar: 1, cargar: cargar }).then(res => {
                setCatalogos(res.data.cats);
                setDialogClientepn(true);
                setCliente(null);
                setActiveIndex(0);
                setdialogIns(true);
                nuevoCliente({
                    id: res.data.clienteId,
                    nombre_completo: res.data.nombre_completo,
                    nemonico: res.data.nemonico,
                    hay_pep: res.data.hay_pep,
                    pid: res.data.pid,
                    estado_pep: res.data.estado_pep,
                    hay_tercero: res.data.hay_tercero,
                    vid: res.data.vid,
                    estado_tercero: res.data.estado_tercero
                });
            }).finally(() => {
                setLoading(false);
                if (getInfo('oid')) {
                    removeKey('oid');
                    confirmacion();
                }
            });
            return;
        }
        else {
            setDialogClientepn(true);
            setCliente(cliente);
            setActiveIndex(0);
            setdialogIns(true);
            if (cliente && cliente?.pep !== undefined) {
                setHayPep(cliente.pep);
            }
        }
    };

    const confirmDelete = (siDelete = true) => {
        const message = siDelete ? '¿Está seguro de eliminar el formulario?' : '¿Está seguro de cancelar el formulario? No podrá reveresar este cambio.';
        confirmDialog({
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => siDelete ? deleteCliente() : setDialogCancelar(true)
        });
    }

    const deleteCliente = () => {
        clientepnSrv.eliminarClientepn(cliente?.id).then(res => {
            if (!siCliente) {
                loadLazyData();
            }
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const confirmacion = () => {
        const message = omodel.confirmacionBVG;
        confirmDialog({
            message: message,
            header: 'Declaración',
            icon: 'pi pi-info-circle',
            acceptLabel: 'Aceptar',
            style: { maxWidth: '400px' },
            accept: () => { },
            footer: (options) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button label="Aceptar" icon="pi pi-check" onClick={options.accept} autoFocus />
                    </div>
                );
            }
        });
    }

    const nuevoCliente = (nuevo) => {
        const _cliente = cliente ?? {};
        if (nuevo) {
            if (nuevo?.id !== undefined) _cliente.id = nuevo.id;
            if (nuevo?.nemonico !== undefined) _cliente.nemonico = nuevo.nemonico;
            if (nuevo?.nombre_completo !== undefined) _cliente.nombre_completo = nuevo.nombre_completo;
            if (nuevo?.identificacion !== undefined) _cliente.identificacion = nuevo.identificacion;
            // Pep
            if (nuevo?.pid !== undefined) _cliente.pid = nuevo.pid;
            if (nuevo?.hay_pep !== undefined) _cliente.hay_pep = nuevo.hay_pep;
            if (nuevo?.estado_pep !== undefined) setPepEstado(nuevo.estado_pep);
            // Vinculación terceros
            if (nuevo?.vid !== undefined) _cliente.vid = nuevo.vid;
            if (nuevo?.hay_tercero !== undefined) _cliente.hay_tercero = nuevo.hay_tercero;
            if (nuevo?.estado_tercero !== undefined) setVinEstado(nuevo.estado_tercero);
        }
        setHayPep(_cliente.hay_pep === true);
        setHayTercero(_cliente.hay_tercero === true);
        // Si cliente es null, y al procesar las propiedades, tenemos {}, asignamos null en vez de {}
        setCliente(Object.keys(_cliente).length === 0 ? null : _cliente);
    }

    const regresar = () => {
        setActiveIndex(0);
        setDialogClientepn(false);
        if (!siCliente) {
            loadLazyData();
        }
    }

    const handleNext = () => {
        if (activeIndex < 7) {
            setActiveIndex(activeIndex + 1);
        }
    };

    const handlePrev = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    };

    const nextPrev = (btn = true) => {
        const btnNext = btn ? <Button label="Siguiente" type="submit" icon="pi pi-chevron-right" /> :
            <Button label="Siguiente" type="button" icon="pi pi-chevron-right" onClick={e => { handleNext(); }} />;
        return (
            <div className="formgrid grid">
                <div className="field col">
                    <Button label="Anterior" icon="pi pi-chevron-left" type="button" onClick={e => handlePrev()} />
                </div>
                <div className="field col">
                    {btnNext}
                </div>
            </div>
        )
    }

    const archivos = () => {
        setDialogSubir(true);
    }

    const reiniciar = () => {
        if (!siCliente) {
            loadLazyData();
        }
        setDialogClientepn(false);
        setDialogSubirPep(false);
        setDialogSubir(false);
        setDialogVinculacion(false);
    }

    const reiniciarPep = (ban) => {
        setActiveIndex(3);
        if (ban && ban === 'ENVIADO') {
            setPepEstado('ENVIADO');
        }
    }

    const archivosPep = () => {
        setDialogSubirPep(true);
    }

    const siOpcion = (strOpcion) => {
        return opcion === 'PRELAFIT' || opcion?.includes(strOpcion);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && ['BORRADOR', 'ENVIADO'].includes(cliente?.nemonico))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        if (siOpcion('form-persona-natural-anexos') && permss?.consultar)
            items.push({ label: 'Anexos formulario', icon: 'pi pi-clone', command: () => { archivos() } });
        if (siOpcion('form-persona-natural-anexos') && permss?.consultar && cliente?.pid)
            items.push({ label: 'Anexos formulario(PEP)', icon: 'pi pi-reddit', command: () => { archivosPep() } });
        if (permss?.consultar && cliente?.vid)
            items.push({ label: 'Anexos formulario - Vinculación', icon: 'pi pi-discord', command: () => { setDialogVinculacion(true) } });
        if (siOpcion('form-persona-natural-cancelar') && ['BORRADOR', 'ENVIADO'].includes(cliente?.nemonico))
            items.push({ label: 'Cancelar formulario', icon: 'pi pi-lock', command: () => { confirmDelete(false) } });
        if (permss?.eliminar && ['BORRADOR', 'ENVIADO'].includes(cliente?.nemonico))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const respuesta = () => {
        setDialogCancelar(false);
        loadLazyData();
    }

    const reiniciarVinculacion = (est) => {
        if (!siCliente) {
            loadLazyData();
        }
        setActiveIndex(3);
        nuevoCliente({ estado_tercero: est });
    }

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            {!dialogClientepn && !siCliente && <>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)}
                    end={generic.rightToolbarTemplate(clientespn, omodel, 'Reporte_persona_natural', 'LISTADO PERSONA NATURAL')}></Toolbar>
                <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    {table({ action01: accionesTbl, reg: setCliente, items: itemsMenu() })}
                </Card></>
            }
            {dialogClientepn &&
                <Panel header="INFORMACIÓN DE PERSONAS NATURALES" style={{ maxWidth: '100%', margin: 'auto' }}>
                    {omodel.titleBVG}
                    <Divider />
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="Sección 1">
                            <DatosGenerales id={cliente?.id} next={handleNext} permss={permss} catalogos={catalogos} nuevoCliente={nuevoCliente}
                                toast={toast} seccion="seccion1" generic={generic} />
                        </TabPanel>

                        <TabPanel header="Sección 2" disabled={cliente == null}>
                            <InformacionLaboral generic={generic} nextPrev={nextPrev} next={handleNext} permss={permss} cliente={cliente} catalogos={catalogos} toast={toast}
                                seccion="seccion2" nuevoCliente={nuevoCliente} />
                        </TabPanel>

                        <TabPanel header="Sección 3" disabled={cliente == null}>
                            <InfFinanciera generic={generic} id={cliente?.id} permss={permss} nextPrev={nextPrev} next={handleNext} catalogos={catalogos} toast={toast} seccion="seccion3" />
                        </TabPanel>

                        <TabPanel header="Sección 4 (final)" disabled={cliente == null}>
                            <Ampliada generic={generic} id={cliente?.id} permss={permss} nextPrev={nextPrev} next={handleNext} catalogos={catalogos} toast={toast}
                                setDialogClientepn={setDialogClientepn} seccion="seccion4" tipo='clientePn' cancelar={getPerss() === undefined} urls={urls} estado={cliente?.nemonico}
                                reiniciar={reiniciar} handlePrev={handlePrev} />
                        </TabPanel>

                        {hayPep && <TabPanel header={(pepEstado === 'ENVIADO' || pepEstado === 'FINALIZADO') ? "Formulario PEP Receptado" : "Sección PEP"}
                            disabled={cliente == null || !cliente?.id || ((pepEstado === 'ENVIADO' || pepEstado === 'FINALIZADO') && siCliente)}>
                            <FormPep tipo="clipn" idp={cliente?.id} id={cliente?.pid} version={cliente?.pep_version} permss={permss} toast={toast} urls={urls} reiniciar={reiniciarPep} setDialogClientepn={setDialogClientepn} />
                        </TabPanel>}

                        {hayTercero && <TabPanel header={(vinEstado === 'ENVIADO' || vinEstado === 'FINALIZADO') ? "Formulario de vinculación receptado" : "Vinculación con terceros"}
                            disabled={cliente == null || !cliente?.id || ((vinEstado === 'ENVIADO' || vinEstado === 'FINALIZADO') && siCliente)}>
                            <VinculacionBvg generic={generic} nextPrev={nextPrev} next={handleNext} handlePrev={handlePrev} permss={permss} cliente={cliente} catalogos={catalogos} toast={toast}
                                seccion="seccion8" nuevoCliente={nuevoCliente} id={cliente?.vid} idp={cliente?.id} tipo="clientePnBvg" urls={urlsVin} reiniciar={reiniciarVinculacion} />
                        </TabPanel>}
                    </TabView>
                </Panel>
            }
            <br />

            {dialogClientepn && !siCliente && <Button label="Regresar" icon="pi pi-replay" onClick={regresar} />}
            {dialogInstruccion(omodel.titulo, omodel.mensajeBVG)}

            <Dialog visible={dialogSubir} header={"Gestión de anexos: " + cliente?.nombre_completo} modal className="p-fluid modal-ssize" onHide={e => setDialogSubir(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="clipn" urls={urls} idp={cliente?.id} toast={toast} permss={permss} estado={cliente?.nemonico} reiniciar={reiniciar} setDialogSubir={setDialogSubir}
                    opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogSubirPep} header={"Gestión de anexos (PEP): " + cliente?.nombre_completo} modal className="p-fluid modal-ssize" onHide={e => setDialogSubirPep(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="clipn" urls={urlsPep} idp={cliente?.pid} toast={toast} permss={permss} estado={cliente?.estado_pep} reiniciar={reiniciar}
                    setDialogSubir={setDialogSubirPep} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogVinculacion} header={"Gestión de anexos (Vinculación): " + cliente?.nombre_completo} modal className="p-fluid modal-ssize"
                onHide={e => setDialogVinculacion(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="clientePnBvg" urls={urlsVin} idp={cliente?.vid} toast={toast} permss={permss} estado={cliente?.estado_tercero}
                    reiniciar={reiniciar} setDialogSubir={setDialogVinculacion} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogCancelar} header={"Cancelar formulario: " + cliente?.nombre_completo} modal className="p-fluid modal-ssize" onHide={e => setDialogCancelar(false)} style={{ width: '400px' }}>
                <Cancelar urls="ficha/persona-natural/cancelar" generic={generic} toast={toast} permss={permss} id={cliente?.id} respuesta={respuesta} hideDialog={setDialogCancelar} />
            </Dialog>
        </>
    )
}
